import React from 'react'
import styled from 'styled-components'
import { IoMdClose } from 'react-icons/io'

import Colors from '../Colors'

const ModalResponsive = ({
    className,
    closeIconVisible = true,
    children,
    title,
    visible,
    onClose,
}) => {
    if (!visible) return null

    return (
        <OverlayPanel className={className}>
            <ModalWindow>
                {title && (
                    <ModalHeaderContainer>
                        <Title>{title}</Title>
                        {closeIconVisible && (
                            <CloseIcon
                                data-testid="modal-close-icon"
                                onClick={onClose}
                            />
                        )}
                    </ModalHeaderContainer>
                )}
                {!title && closeIconVisible && (
                    <CloseIcon
                        data-testid="modal-close-icon"
                        onClick={onClose}
                    />
                )}
                {children}
            </ModalWindow>
        </OverlayPanel>
    )
}

const OverlayPanel = styled.div`
    position: fixed;
    z-index: 9997;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(5, 45, 62, 0.7);
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
`

const ModalHeaderContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 12px 0 24px;
`

const Title = styled.span`
    font-family: Roboto;
    font-size: 16px;
    font-weight: bold;
    line-height: 1.75;
    letter-spacing: 0.44px;
    text-align: left;
    color: #333;
`

const ModalWindow = styled.div`
    background-color: ${Colors.white};
    border-radius: 4px;
    height: fit-content;
    margin: 5vh;
`

const CloseIcon = styled(IoMdClose)`
    cursor: pointer;
    margin: 4px;
    float: right;
`

export default ModalResponsive
